import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type { StoryContent } from "../../@types/portalAluno";
import { getStoryContents } from "../../services/portalAluno/stories/storiesService";
import type { ApplicationState } from "../../store";

export const portalStoryContentsQueryKey = (
  idUsuario?: number,
  storyId?: number | null
) => ["portal-aluno", "story-conteudo", idUsuario, storyId];

const useStoryContents = (storyId?: number | null) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery<StoryContent[]>({
    enabled: Boolean(idUsuario && storyId),
    queryKey: portalStoryContentsQueryKey(idUsuario, storyId),
    queryFn: () => getStoryContents(storyId as number),
    staleTime: 60 * 1000,
  });
};

export default useStoryContents;
